export default __webpack_public_path__ + "media/amberVid.7eba2f94.mp4";